import React from 'react';

const DispCatg = ({ listCatg, category, setCategory, theme }) => {
    const chipStyle = (isActive) => ({
        padding: '10px 22px',
        borderRadius: '50px',
        border: isActive ? `2px solid ${theme.primary}` : '1px solid #ddd',
        backgroundColor: isActive ? theme.primary : '#fff',
        color: isActive ? '#fff' : theme.textDark,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        fontWeight: '600',
        fontSize: '0.85rem',
        transition: '0.2s all',
        boxShadow: isActive ? '0 4px 8px rgba(230, 81, 0, 0.3)' : 'none'
    });

    return (
        <div style={{ margin: '20px 0' }}>
            <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', paddingBottom: '10px', scrollbarWidth: 'none' }}>
                <button style={chipStyle(category === "All")} onClick={() => setCategory("All")}>All Menu</button>
                {listCatg.map((cat) => (
                    <button key={cat._id} style={chipStyle(category === cat.catgory)} onClick={() => setCategory(cat.catgory)}>
                        {cat.catgory}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default DispCatg;